import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Theme } from '../../../../interfaces/enums/Theme.enum';
import { getQuoteCostHeadlineInformation } from '../../../../store/slices/quote/quote.store';
import { withBlokWrapper } from '../../../BlokWrapper/BlokWrapper';
import { asCurrencyString } from '../../../../utils/asCurrencyString/asCurrencyString.util';
import { getIsLoading } from '../../../../store/slices/loading.store';
import { QuoteContext } from '../../../../contexts/Quote';

interface QuoteTotalBarProps {
  total_label: string;
}

const QuoteTotalBar: React.FC<QuoteTotalBarProps> = ({ total_label }) => {
  const { quoteCostBreakdown } = useContext(QuoteContext);

  const grandTotal = quoteCostBreakdown?.headlineInformation?.grandTotal;

  return (
    <div className="w-full flex items-center justify-between px-10 py-8 text-text/body">
      <p className="font-dm-serif-display text-4xl">{total_label}</p>
      {grandTotal && (
        <p className="font-bold text-5xl">{asCurrencyString(grandTotal!)}</p>
      )}
    </div>
  );
};

export default memo(withBlokWrapper(QuoteTotalBar, Theme.DARK));
